module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_8003.1fcaa406.png";